export var RestoreAccountTagSubject;
(function (RestoreAccountTagSubject) {
    RestoreAccountTagSubject["RESTORE_ACCOUNT_TAG_SUBJECT_TAG_KEYS"] = "TAG_KEYS";
    RestoreAccountTagSubject["RESTORE_ACCOUNT_TAG_SUBJECT_TAG_KEY_VALUES"] = "TAG_KEY_VALUES";
})(RestoreAccountTagSubject || (RestoreAccountTagSubject = {}));
